import { t } from 'i18next';
export const ErrorCode = {
  SUCCESS: 1000,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
} as const;

export interface ErrorMessage {
  [key: number]: string;
}

export const DefaultErrorMessages: ErrorMessage = {
  [ErrorCode.BAD_REQUEST]: t('network.bad-request'),
  [ErrorCode.UNAUTHORIZED]: t('network.unauthorized'),
  [ErrorCode.FORBIDDEN]: t('network.forbidden'),
  [ErrorCode.NOT_FOUND]: t('network.not-found'),
  [ErrorCode.INTERNAL_ERROR]: t('network.internal-error'),
};

export const handleErrorMessage = (code: number, serverMsg?: string): string => {
  if (DefaultErrorMessages[code]) {
    return DefaultErrorMessages[code];
  }
  
  // Try to use i18n for business error codes
  const i18nKey = `apiError.${code}`;
  const translated = t(i18nKey);
  
  // If translation exists (i18next returns the key if not found, 
  // but sometimes it returns empty string or the key depending on config.
  // We can check if it's equal to the key)
  if (translated && translated !== i18nKey) {
    return translated;
  }

  return serverMsg || `Error ${code}`;
}; 
 